<template>
	<div class='knd-story'>
		<div class='wrap wrap--620'>
			<OpenLayersMap />
		</div>
	</div>
</template>

<script>
	import OpenLayersMap from '@/story/openlayers/';	

	const vueObject = {
		components: {OpenLayersMap}
	}

	export default vueObject;
</script>